import React from 'react';
import { withTranslation } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';
import { ChevronRight } from 'lucide-react';
import './InfoTile.sass';

class InfoTile extends React.Component {
  #icon;
  #title;
  #subtitle;
  #cta;
  #to;
  #onClick;
  #hint;

  constructor(props) {
    super(props);
    this.#icon = props.icon;
    this.#title = props.title;
    this.#subtitle = props.subtitle;
    this.#cta = props.cta;
    this.#to = props.to;
    this.#onClick = props.onClick;
    this.#hint = props.hint;
  }

  render() {
    const { t } = this.props;
    return (
      <HashLink to={this.#to} className="InfoTile" onClick={this.#onClick}>
        <div className="InfoTile__icon">{this.#icon}</div>
        <div className="InfoTile__body">
          <h3 className="InfoTile__title">{this.#title}</h3>
          <p className="InfoTile__subtitle">{this.#subtitle}</p>
          <span className="InfoTile__cta">
            {this.#cta} <ChevronRight size={18} />
          </span>
          <span className="InfoTile__hint">{this.#hint || t('tileGoToSubpage')}</span>
        </div>
      </HashLink>
    );
  }
}

export default withTranslation()(InfoTile);
